import React from 'react';
import { dateOptions } from '../../utils/dates';

const FireFlowTestTableRow = ({ report, onSelect }) => {
  console.log(report);
  return (
    <tr key={report.fireFlowTestHydrantId} id={report.fireFlowTestHydrantId}>
      <td>{report.testDate ? new Date(report.testDate).toLocaleDateString('en-US', dateOptions) : ''}</td>
      <td>{report.nfpaClassificationColor}</td>
      <td>{report.nfpaClassificationRating}</td>
      <td>{report.nfpaClassificationValue.toFixed(2)}</td>
      <td className='actions'>
        <div className='link' onClick={() => onSelect(report.fireFlowTestHydrantId)}>Select</div>
      </td>
    </tr>
  );
};

export default FireFlowTestTableRow;